import React, { useState } from 'react'
import { useNavigate, useLoaderData } from 'react-router-dom'
import { Role } from './types'

export const loadRole = async (): Promise<Role> => {
    return fetch(
        process.env.REACT_APP_API_URL + '/api/backend/v1/organizations/roles/',
        {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )
        .then((response) => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error('Failed to fetch organization')
            }
        })
        .catch((e) => {
            console.error(e)
        })
}

const OrgRolesPage: React.FC = () => {
    const navigate = useNavigate()
    const loaderData = useLoaderData() as { result: Role[] }
    const roleLoad = loaderData.result || [] // Извлекаем массив из `result`

    // Инициализация состояния
    const [roleData, setRoleData] = useState<Role[]>(roleLoad)

    return (
        <div className="flex flex-col text-[#181818] dark:text-[#FFFFFF] h-full">
            <div className="bg-[#e5e5e5] dark:bg-[#111111]">
                <div className="w-auto h-20 mx-6 flex flex-row gap-x-5 ">
                    <div className="w-60 h-20 my-auto content-center ">
                        <p className="text-sm text-[#181818] dark:text-[#FFFFFF]">
                            Реестр ролей
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-1 justify-center max-h-[calc(100vh_-_80px)] p-5 bg-[#f0f3f5] dark:bg-[#181818]">
                <div className="flex flex-col h-full w-[800px] space-y-10">
                    {/* // body */}
                    <div className="flex h-[calc(100vh_-_120px)] bg-[#f0f3f5] dark:bg-[#181818]">
                        {/* table */}
                        <div className="flex flex-col w-full min-w-fit rounded">
                            {/* toolbar */}
                            <div className="flex flex-row gap-1 p-2 rounded-t-lg text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033]">
                                <div className="w-6 h-6"></div>
                            </div>

                            {/* name */}
                            <div className="flex flex-row gap-1 px-1 py-2 h-10 text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#e4e7ea] dark:bg-[#262427]">
                                <div className="flex w-10 items-center justify-center text-center">
                                    №
                                </div>
                                <div className="flex flex-1 items-center justify-center text-center">
                                    Наименование роли
                                </div>
                            </div>

                            {/* data */}
                            <div className="flex flex-col gap-1 py-1 h-dvh overflow-y-auto bg-[#e4e6e8] dark:bg-[#1D1C1E] custom-scrollbar">
                                {/* Вывод структуры данных */}
                                <>
                                    {roleData.map((list, index) => (
                                        <div
                                            key={list.guid}
                                            className="flex flex-row gap-1 mx-1 rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                        >
                                            <div className="flex py-2 w-10 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                {index + 1}
                                            </div>
                                            <div className="flex py-2 flex-1 items-center justify-start text-left">
                                                {list.name}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            </div>

                            {/* buttons */}
                            <div className="flex flex-row gap-1 p-2 rounded-b-lg h-10 space-x-2 text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrgRolesPage
